"use client";

import { useEffect, useState } from "react";
import Link from "next/link";

import MarketTicker from "./MarketTicker";

export default function HeaderInfo() {
  const [time, setTime] = useState<string>("");
  const [day, setDay] = useState<string>("");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setDay(new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }).format(now));
      setTime(new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true }).format(now));
    };

    updateTime();
    const timer = setInterval(updateTime, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="border-b border-border bg-background py-0.5 px-4 md:px-8">
      <div className="w-full flex items-center justify-between text-[10px] font-black uppercase tracking-widest text-muted-foreground/30">

        {/* Status Indicator */}
        <div className="flex items-center gap-4 py-1">
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
            <span className="text-foreground font-black tracking-tight uppercase">Live Global Intelligence Feed</span>
          </div>
        </div>

        {/* Market Intelligence Ticker (Silicon Valley Standard) */}
        <div className="flex items-center gap-4 flex-1 min-w-0 ml-8">
          <div className="flex-1 min-w-0 overflow-hidden">
            <MarketTicker />
          </div>
          <div className="border-l border-border/60 pl-4 flex-shrink-0 flex items-center gap-2">
            <Link
              href="/markets"
              className="hidden md:flex hover:text-green-500 transition-colors text-[10px] border border-green-500/40 px-3 py-1 bg-green-500/5 shadow-sm rounded-sm font-black text-green-600 dark:text-green-400 whitespace-nowrap items-center gap-1.5"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
              Live Markets
            </Link>
            <Link 
              href="/digital-edition"
              className="hover:text-brand transition-colors text-[10px] border border-border px-3 py-1 bg-background shadow-sm rounded-sm font-black text-foreground whitespace-nowrap"
            >
              Digital Edition
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
}
